<template>
  <div class="com-step">
    <p v-if="subText" class="upload-tips">{{ subText }}</p>
    <p v-if="showFormatTips" class="upload-tips">{{ `（上限${fileLimit}个，每个附件大小不超过${sizeLimit}M，仅支持png、jpg、jpeg格式）` }}</p>
    <div class="file-upload-trigger clearfix">
      <a-upload
        :file-list="fileList"
        :customRequest="handleUpload"
        list-type="picture-card"
        name="file"
        accept=".png, .jpg, .jpeg"
        :transformFile="handleTransformFile"
        :beforeUpload="handleBeforeUpload"
        :locale="{
          removeFile: '删除',
          previewFile: '预览'
        }"
        @preview="handlePreview"
        @change="handleUploadChange"
      >
        <div v-if="fileList.length < fileLimit">
          <a-icon type="plus" />
        </div>
      </a-upload>
      <div v-if="fileTypeTitle" class="file-upload-name">{{ fileTypeTitle }}</div>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </div>
  </div>
</template>

<script>
import imageCompression from 'browser-image-compression'
import { refundOrderUpload, jjcCertUpload } from '@/apis/order'

// 图片压缩
const compressImage = async (file) => {
  let compressedFile = null
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: false
  }
  try {
    compressedFile = await imageCompression(file, options)
  } catch (error) {
    compressedFile = null
    console.log('图片压缩失败 >>>> ', error)
  }

  return compressedFile
}

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }).catch((err) => {
    console.error(err)
  })
}

export default {
  name: 'file-upload',
  data () {
    return {
      fileList: [],
      previewVisible: false,
      previewImage: ''
    }
  },
  props: {
    subText: {
      type: String
    },
    fileLimit: {
      type: Number,
      default: 5
    },
    sizeLimit: {
      type: Number,
      default: 5
    },
    seller: {
      type: String
    },
    sellerChannel: {
      type: String
    },
    showFormatTips: {
      type: Boolean,
      default: true
    },
    fileTypeTitle: {
      type: String,
      default: ''
    },
    isJJC: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 取消预览
    handleCancelPreview () {
      this.previewVisible = false
    },
    // 图片预览
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleUploadChange ({ fileList }) {
      this.fileList = fileList.filter(file => {
        return file.size <= 1024 * 1024 * this.sizeLimit && file.status !== 'error'
      })
      this.$emit('setFileList', this.fileList)
    },
    // 图片上传限制
    handleBeforeUpload (file) {
      // 确保文件对象已经准备好
      return new Promise((resolve, reject) => {
        // 限制上传超过 5M 的图片
        const { sizeLimit } = this
        if (file && file.size && file.name) {
          // 限制上传超过 5M 的图片
          if (file.size > 1024 * 1024 * sizeLimit) {
            this.$message.error(`上传的附件大小不能超过${sizeLimit}M！`)
            reject(new Error(`上传的附件大小不能超过${sizeLimit}M！`))
            return
          }

          // 有些移动设备的浏览器/APP能够上传其他类型的文件，限制只能上传图片
          if (!/(.jpg|.jpeg|.png)$/g.test(file.name)) {
            this.$message.error('仅支持上传图片的类型：".png", ".jpg", ".jpeg"！')
            reject(new Error('仅支持上传图片的类型：".png", ".jpg", ".jpeg"！'))
            return
          }

          resolve(file)
        } else {
          // 如果文件对象尚未准备好，延迟处理
          resolve(file)
        }
      })
    },
    // 图片压缩
    async handleTransformFile (file) {
      const compressedFile = await compressImage(file)
      return compressedFile || file
    },
    // 图片上传
    async handleUpload (options) {
      try {
        let params = {}
        let uploadRequest
        if (this.isJJC) {
          uploadRequest = jjcCertUpload
          const base64Data = await getBase64(options.file)
          const file = base64Data?.split(',')?.[1] || ''
          params = { file }
        } else {
          uploadRequest = refundOrderUpload
          params = new FormData()
          params.append('file', options.file, options.file.name)
          params.append('seller', this.seller)
          params.append('sellerChannel', this.sellerChannel)
        }
        const data = await uploadRequest(params)
        options.onSuccess(data, options)
      } catch (error) {
        options.onError(error)
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style lang="less">
.file-upload-name {
  text-align: center;
}
</style>
